import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleField, SecretPasswordField } from '../../../components';
import { Field } from 'formik';

interface OutlineFormProps {};

function OutlineForm(props: OutlineFormProps) {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 space-x-0 lg:space-x-12">
            <div className="flex-1">
                <h2 className="mt-4 mb-1 text-base font-semibold leadin text-lg text-gray-900 dark:text-gray-100">
                    {t('settings.outline')}
                </h2>
                <div className="mt-5">
                    <div className="mt-2 flex space-between">
                        <label htmlFor="enable" className="flex-1 text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                            {t('settings.enable_outline')}
                        </label>
                        <ToggleField name="outline.enabled" className="inline"/>
                    </div>
                </div>
                <div className="mt-5">
                    <label htmlFor="url" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                        {t('settings.outline_url')}
                    </label>
                    <div className="mt-2">
                        <Field
                            type="text"
                            name="outline.url"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="https://docs.example.com"
                        />
                    </div>
                </div>
                <div className="mt-5">
                    <label htmlFor="api_key" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                        {t('settings.outline_api_key')}
                    </label>
                    <div className="mt-2">
                        <SecretPasswordField
                            name="outline.api_key"
                            hasFlagName="outline.hasApiKey"
                            placeholder="ol_api_..."
                        />
                    </div>
                </div>
                <div className="mt-5">
                    <label htmlFor="rootDocumentId" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                        {t('settings.outline_root_document_id')}
                    </label>
                    <div className="mt-2">
                        <Field
                            type="text"
                            name="outline.rootDocumentId"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="00000000-0000-0000-0000-000000000000"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OutlineForm;
